import React from "react";
import { Link } from "gatsby";
import { Container, Row, Col } from "react-bootstrap";
import parse from 'html-react-parser';
import ScrollAnimation from 'react-animate-on-scroll';
import Buttons from "../Buttons/Buttons";
import CalculatorBlock from "@Components/Static/CalculateBlock/CalculateBlock"
import './CalculatorBlock.scss';

const CalculatorBlocks = (props) => {
    const { Content } = props

    return (
        <section className={`calculator-wrapper-section `} >
            <Container>
                <Row className="content-block">
                    <Col lg={12}>
                        {Content && <>{parse(Content)}</>}
                    </Col>
                </Row>
                <Row className={`d-flex`}>
                    <Col lg={6}>

                        <CalculatorBlock
                            collection={"Mortgage_Calculator"}
                            isLanding={true}
                        />

                    </Col>
                    <Col lg={6}>
                        <CalculatorBlock
                            collection={"Stamp_Duty_Calculator"}
                            isLanding={true}
                        />


                    </Col>
                </Row>
            </Container>
        </section>
    )
}

export default CalculatorBlocks